import { getCalendarRanges } from "./constants";
import { ECalendarRange } from "./types";

export const getCalendarState = (value: {
  startDate: Date | null;
  endDate: Date | null;
}) => {
  const calendarRanges = getCalendarRanges();

  return {
    startDate: value.startDate
      ? value.startDate
      : calendarRanges[ECalendarRange.WEEK].range().startDate,
    endDate: value.endDate
      ? value.endDate
      : calendarRanges[ECalendarRange.WEEK].range().endDate,
  };
};
